export const SNACKBAR = {
    BASE: 'primary',
    SUCCESS: 'success',
    INFO: 'info',
    ERROR: 'error',
    WARNING: 'warning' 
  };